import { Truck, Building2, Zap, MapPin, Timer, WashingMachine } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";

const trustItems = [
  { icon: Truck, text: 'Free Pickup & Delivery' },
  { icon: Building2, text: 'Residential & Commercial' },
  { icon: Zap, text: 'Fast Turnaround' },
  { icon: MapPin, text: 'Mountain Home & Area' },
  { icon: Timer, text: 'Award-Winning Service' },
  { icon: WashingMachine, text: 'Large Capacity Machines' },
];

export default function TrustBar() {
  return (
    <section className="bg-poly-blue py-6 relative overflow-hidden" data-testid="trust-bar">
      <img src={LOGO_URL} alt="" className="logo-watermark absolute right-4 top-1/2 -translate-y-1/2 w-24 h-24 opacity-[0.08]" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {trustItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 text-white/90 justify-center py-2"
              data-testid={`trust-item-${i}`}
            >
              <item.icon className="w-5 h-5 text-poly-blue-light shrink-0" />
              <span className="text-sm font-medium whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
